import { useScreenLayout } from '@/hooks/screen'
import { useNavigation } from 'expo-router'
import { useEffect } from 'react'

export const useCloseOnNavigationEvent = (isOpened: boolean, close: () => void): void => {
    const screenLayout = useScreenLayout()

    const navigation = useNavigation()

    useEffect(() => {
        if (!isOpened || screenLayout !== 'compact') return

        return navigation.addListener('state', close)
    }, [isOpened, screenLayout, navigation, close])
}
